import { IResponseModel } from "../../IResponseModel";
import { DiscordServerBasicInfo } from "../../shared/DiscordServerBasicInfo";

export class ServerListResponse implements IResponseModel {
    server_list: DiscordServerBasicInfo[];
}